import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import { css } from '@emotion/core';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';

export const modes = {
    DAY: 1,
    WEEK: 2
};

const listConfig = [
    { label: () => i18n.t('label.period_play.mode.day'), value: modes.DAY },
    { label: () => i18n.t('label.period_play.mode.week'), value: modes.WEEK }
];

export default function PeriodPlayModeSelector({ value, onChange, style, disabled }) {
    const lists = useMemo(
        () =>
            listConfig.map(t => (
                <MenuItem value={`${t.value}`} key={t.value}>
                    {t.label()}
                </MenuItem>
            )),
        []
    );
    return (
        <Select
            css={[selectorStyle, css(style)]}
            value={value}
            onChange={e => {
                const { value } = e.target;
                onChange(value);
            }}
            variant="outlined"
            disabled={disabled}
            fullWidth
        >
            {lists}
        </Select>
    );
}

PeriodPlayModeSelector.propTypes = {
    style: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    value: PropTypes.number,
    onChange: PropTypes.func,
    disabled: PropTypes.bool
};

const selectorStyle = css`
    background-color: #fff;
    font-size: 14px;
    & .MuiSelect-root {
        padding-top: 10px;
        padding-bottom: 10px;
    }
    & fieldset {
        border: none;
    }
`;
